(ns iris.styles.settings
  (:require
   ;;    [herb.core :refer [<class <id]]
   ;; [garden.units :refer [px]]
   [shadow.css :refer [css]]))


(def $settings-btn
  ["btn"
   (css
    {:position "relative"
     :float "right"
     :margin-top "8px"
     :margin-right "5px"
     :background-color "rgb(0, 0, 128)"
     :border-color "#333"
     :color "white !important"}
    [:hover {:color "white !important"
             :filter "brightness(120%)"}])])

;; (defn settings-btn []
;;   ^{:pseudo {:hover {:color "white !important"}}}
;;   {:position "relative"
;;    :float "right"
;;    :margin-top "8px"
;;    :margin-right "5px"
;;    :background-color "rgb(0, 0, 128)"
;;    :border-color "#333"
;;    :color "white !important"
;; ;;   &:hover, &:active, &:visited{
;; ;;     color: white !important;
;; ;;   }
;;    })